import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Heading } from '../../../components/Heading/Heading';
import { SlipwayIcon } from '../../../components/Icons/Map/SlipwayIcon';
import { StructureIcon } from '../../../components/Icons/Map/StructureIcon';
import { SunkenTreeIcon } from '../../../components/Icons/Map/SunkenTreeIcon';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { Text } from '../../../components/Text/Text';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneOne from './assets/phoneOne.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHING_WAYPOINTS_TITLE,
  META_FISHING_WAYPOINTS_DESCRIPTION,
  META_FISHING_WAYPOINTS_CANONICAL,
} from '../../../constants/metadata';

export const WaypointsPage: NextPageWithLayout = () => {
  return (
    <div>
      <MetaTags
        title={META_FISHING_WAYPOINTS_TITLE}
        description={META_FISHING_WAYPOINTS_DESCRIPTION}
        link={META_FISHING_WAYPOINTS_CANONICAL}
      />
      <HeaderSection
        headingText="Plan and prepare with waypoints"
        bodyText=" Have you ever been out fishing and found a great honey-hole, but didn’t quite remember
          where that spot was next time you were out? Drop a waypoint in the Fishbrain app by
          long-pressing anywhere on the map. Add a note, change the icon, and customize the title.
          You’ll never have to remember that honey-hole ever again."
      />
      <CircleImageAndText
        imgSrc={phoneOne}
        imgAlt="Never forget that honey-hole with the fishbrain app"
        headingText="Never forget that honey-hole"
        bodyText="Waypoints allows you to mark exactly where you found a great catch in the past. Whether that was a school of fish, great fishing spot, or where you caught your latest personal best, drop a waypoint and remember it for later."
      />

      <CircleImageAndText imgSrc={phoneTwo} imgAlt="Fishing regulation made easy" imgRight>
        <div className="sm:w-col-7 md:w-col-5 mt-6">
          <div className="flex gap-3">
            <StructureIcon size={32} className="min-w-8" />
            <Heading variant="sm">Remember specific structures</Heading>
          </div>
          <Text variant="lg" className="mt-4">
            Want to avoid the spot where you lost your lure? Note down that particularly good patch
            of weeds where you landed that monster? Fishbrain has you covered.
          </Text>
        </div>

        <div className="sm:w-col-7 md:w-col-5 mt-6">
          <div className="flex gap-3">
            <SlipwayIcon size={32} className="min-w-8" />
            <Heading variant="sm">Make your fishing trip easier</Heading>
          </div>
          <Text variant="lg" className="mt-4">
            Want a picnic area nearby? Or a slipway for your boat? Track the amenities you care
            about including parking, shelter, bonfires, gas, and electricity.
          </Text>
        </div>

        <div className="sm:w-col-7 md:w-col-5 mt-6">
          <div className="flex gap-3">
            <SunkenTreeIcon size={32} className="min-w-8" />
            <Heading variant="sm">Your custom map</Heading>
          </div>
          <Text variant="lg" className="mt-4">
            Add your own notes and photos to customise your map for the way you like to fish.
          </Text>
        </div>
      </CircleImageAndText>
      <AppDownloadSection />
    </div>
  );
};
